// AdminPage - Página principal do admin
import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import AdminLayout from '@/layouts/AdminLayout/AdminLayout';
import AdminDashboard from '../../components/Admin/AdminDashboard';
import TutorialManager from '../../components/Admin/TutorialManager';
import CategoryManager from '../../components/Admin/CategoryManager';
import MediaLibrary from '../../components/Admin/MediaLibrary';
import HeaderMenuManager from '../../components/Admin/HeaderMenuManager/HeaderMenuManager';
import BaseConhecimentoViewer from '../../components/Admin/BaseConhecimentoViewer';

const AdminPage = () => {
  const { user, hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  if (!user) {
    return (
      <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', textAlign: 'center', padding: '2rem' }}>
        <div>
          <h2 style={{ marginBottom: 8 }}>Acesso Negado</h2>
          <p style={{ color: '#64748b' }}>Você precisa estar logado para acessar esta página.</p>
        </div>
      </div>
    );
  }

  const sections = [
    { id: 'dashboard', label: 'Dashboard', permission: null },
    { id: 'tutorials', label: 'Tutoriais', permission: 'create_tutorial' },
    { id: 'categories', label: 'Categorias', permission: 'manage_categories' },
    { id: 'header-menus', label: 'Menus do Header', permission: 'manage_categories' },
    { id: 'media', label: 'Mídia', permission: 'upload_media' },
    { id: 'knowledge-base', label: 'Base de Conhecimento', permission: null },
  ].filter((section) => !section.permission || hasPermission(section.permission));

  return (
    <AdminLayout sections={sections} activeSection={activeTab} onSelectSection={setActiveTab}>
      <div style={{ padding: '2rem' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', margin: 0 }}>Painel Administrativo</h1>
          <p style={{ color: '#64748b', margin: '4px 0 0' }}>Bem-vindo, {user.name}!</p>
        </div>

        {activeTab === 'dashboard' && <AdminDashboard />}
        {activeTab === 'tutorials' && <TutorialManager />}
        {activeTab === 'categories' && <CategoryManager />}
        {activeTab === 'header-menus' && <HeaderMenuManager />}
        {activeTab === 'media' && <MediaLibrary />}
        {activeTab === 'knowledge-base' && <BaseConhecimentoViewer />}
      </div>
    </AdminLayout>
  );
};

export default AdminPage;
